<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Gestión de Roles</span>
      </h5>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Crear área</strong>
            </h5>
          </div>
        </div>
        <b-form @submit="save" @reset="onReset">
          <div class="row">
            <div class="col-md-6">
              <b-form-group id="input-group-1" label="Nombre:" label-for="input-2" description="Ejemplo: Ciencias">
                <b-form-input id="input-1" v-model="form.name" required placeholder="Ingrese el nombre del área"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group id="input-group-2" label="Descripción:" label-for="input-2" description="Puede agregar una breve descripción.">
                <b-form-input id="input-2" v-model="form.description" placeholder="Descripción del área"></b-form-input>
              </b-form-group>
            </div>
          </div>
          <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
        </b-form>
        <a-divider />
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Lista de áreas</strong>
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <a-table :columns="columns" :dataSource="data" rowKey="id">
                 <div slot="action" slot-scope="area">
                  <a @click="() => openModal(area)">Editar</a>
                  <!-- <a-popconfirm title="¿Desea eliminar este grado?" okText="Si" cancelText="No" @confirm="remove">
                    <a>Eliminar</a>
                  </a-popconfirm> -->
                </div>
              </a-table>
            </h5>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="edit-area" ref="modal" title="Editar grado" hide-footer>
      <b-form @submit="edit" ref="todoform">
        <b-form-group id="input-group-1-edit" label="Nombre:" label-for="input-2" description="Ejemplo: Ciencias">
          <b-form-input id="input-1-edit" v-model="areaToEdit.name" required placeholder="Ingrese el nombre del área"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-2-edit" label="Descripción:" label-for="input-2" description="Puede agregar una breve descripción.">
          <b-form-input id="input-2-edit" v-model="areaToEdit.description" placeholder="Descripción del área"></b-form-input>
        </b-form-group>
        <b-button @click="$bvModal.hide('edit-area')" variant="secondary" size="sm" class="mr-2 mb-3 mt-3">Cancelar</b-button>
        <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import apiClient from '@/services/axios'
import { mapState } from 'vuex'
import { showErrorMessage } from '@/services/utilities'

const columns = [
  { title: 'Código', dataIndex: 'id', key: 'id' },
  { title: 'Nombre', dataIndex: 'name', key: 'name' },
  { title: 'Descripción', dataIndex: 'description', key: 'descprition' },
  { title: 'Acción', dataIndex: '', key: 'x', scopedSlots: { customRender: 'action' } },
]

export default {
  name: 'ManagementArea',
  data() {
    return {
      form: {
        name: '',
        description: '',
      },
      areaToEdit: {
        name: '',
        description: '',
      },
      data: null,
      columns,
    }
  },
  computed: {
    ...mapState(['user']),
  },
  beforeRouteEnter (to, from, next) {
    apiClient.get('/areas').then(response => {
      next(vm => vm.setData('', response.data.results.rows))
    }).catch(err => {
      next(vm => vm.setData(err, [])) // TODO Mostrar error
    })
  },
  methods: {
    setData (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.data = data
      }
    },
    save(evt) { // Guarda un grado llamando a la API
      evt.preventDefault()
      this.form.idSchool = this.$store.state.user.idSchool
      apiClient.post('/areas', this.form).then(response => {
        this.data.push(response.data)
        this.form.name = ''
        this.form.description = ''
        this.$notification.success({
          message: 'Creado exitosamente',
          description: `El área ${response.data.name} fue creada con éxito.`,
        })
      }).catch(err => {
        this.$notification.success({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
    },
    remove() { // Elimina un grado - Aun no implementado
      alert('Eliminado :D')
    },
    openModal(areaIn) { // Abre el modal para editar el grado
      this.areaToEdit = Object.assign({}, areaIn)
      this.$bvModal.show('edit-area')
    },
    edit(evt) { // Edita un grado llamando a la API
      evt.preventDefault()
      apiClient.patch(`/areas/${this.areaToEdit.id}`, this.areaToEdit).then(response => {
        this.data = this.data.map(x => (x.id === response.data.id) ? response.data : x)
        this.$notification.success({
          message: 'Modificación exitosa',
          description:
            `Se modificó el área ${response.data.name} correctamente.`,
        })
        this.$bvModal.hide('edit-area')
      }).catch(err => {
        this.$notification.success({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(err),
        })
      })
    },
    onReset(evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.name = ''
      this.form.description = ''
    },
    // handleOk(bvEvt) {
    //   // This assumes the root element of the todo form is the <form>
    //   // this.$refs.todoform.$el.submit()
    //   // Alternatively, if your Todo Form exposes a submit method
    //   this.$refs.todoform.submit()
    //   this.$refs.form.submit()
    // },
  },
}
</script>
